module.exports = __webpack_public_path__ + "static/media/TG.7dac9dbe.png";